// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__WPD8i","list":"BalanceDue_list__3r6UT","listRow":"BalanceDue_listRow__2VlXW","total":"BalanceDue_total__3i6tR"};